/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-19 15:06:40
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-05 11:47:42
 */

import {Button, Modal, Popconfirm, Space, Switch, TableColumnType, Tooltip} from 'antd'
import moment from 'moment'
import React from 'react'
import { DateTimeFormatSimple } from '../../models/datetime'
import { decrypt } from '../../models/m'

export const Columns = (
  onClick: (id: number, action: 'check' | 'buy' | 'repeal', t?: any) => void,
  startIndex: number,
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: '4rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '患者姓名',
      align: 'center',
      width: '6rem',
      ellipsis:true,
      dataIndex: 'patientName',
    },
    {
      title: '联系方式',
      align: 'center',
      width: '8rem',
      ellipsis:true,
      dataIndex: 'patientPhone',
      render: (_, r) => {
        return r?.patientPhone ? decrypt(r?.patientPhone) : '-'
      },
    },

    {
      title: '接诊医生',
      align: 'center',
      width: '6rem',
      ellipsis:true,
      dataIndex: 'treatmentDoctorName',
    },
    {
      title: '开方时间',                        
      align: 'center',
      width: '10rem',
      ellipsis:true,
      dataIndex: 'createTime',
    },
    {
      title: '处方有效期',
      align: 'center',
      width: '8rem',
      ellipsis:true,
      dataIndex: 'ybValidDays',

    },
    {
      title: '处方有效期截止',
      align: 'center',
      width: '8rem',
      ellipsis:true,
      dataIndex: 'ybValidEndtime',
    },
    {
      title: '外配处方编号',
      align: 'center',
      width: '8rem',
      ellipsis:true,
      dataIndex: 'ybExternalNo',

    },
    {
      title: '原处方编号',
      align: 'center',
      width: '8rem',
      ellipsis:true,
      dataIndex: 'ybInitRxno',

    },
    {
      title: '上传状态',
      align: 'center',
      width: '6rem',
      ellipsis:true,
      dataIndex: 'treatmentType',
      render: (_, t) => t.treatmentType == '1' ? '成功' : '失败'
    },
    {
      title: '上传失败原因',
      align: 'center',
      width: '10rem',
      ellipsis:true,
      dataIndex: 'recipeContent',
      render: function Element(_, t) {
        {
          return <div   onClick={() => {
            Modal.info({
              title: '提示',
              content: t?.recipeContent,
              okText: '确认',
              cancelText: '取消',

            })
          }}>{t?.recipeContent}</div>

        }
      },
    },
    {
      title: '是否已撤销',
      align: 'center',
      width: '8rem',
      ellipsis:true,
      dataIndex: 'ybInitRxno',
      render: (_, t) => t.ybRxFlag == 0 ? '是' : '否'
    },
    {
      title: '操作',
      align: 'center',
      dataIndex: 'id',
      key: 'id',
      width:'18rem',
      render: function Element(_, t) {
        {
          return t.treatmentType == 1 ? (
            <Space>
          <Button
            type='primary'
            size='small'
            onClick={() => {
              onClick(t.ybExternalNo, 'check', t)
            }}
            ghost
          >
            审核结果查询
          </Button>
          <Button type='primary' size='small' onClick={() => {
            onClick(t.ybExternalNo, 'buy', t)
          }}>
            购药结果查询
          </Button>
          <Button type='primary' danger size='small' onClick={() => {
                onClick(t.id, 'repeal', t)
          }}>
            撤销
          </Button>
        </Space>
          ) : ''
        } 
      },
    },
  ]
}
